import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQueryClient } from "react-query";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";

import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import { Box, Button, Grid, Tooltip } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { createTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../components/chip/chipCmp";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { TABLE_FILTER } from "../../config/cacheKey";
import { PaginationInfo } from "../../models/cartable.model";
import {
  GetDeferredOnlineInstallmentsResponse,
  TableFilter,
  TableReportRequest,
} from "../../models/report.model";
import {
  GetDeferredOnlineInstallments,
  GetDeferredOnlineInstallmentsReportExcel,
} from "../../services/report.service";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { IDropdownResponse } from "../../models/dropdown.model";
import {
  GetLoanTemplates,
  GetOrganizations,
} from "../../services/cartable.service";
import { GetFinancialSuppliers } from "../../services/dropdown.service";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import AutocomplateCheckbox from "../../components/dropdown/AutocomplateCheckbox";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "customerFullName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کد ملی متقاضی" },
  { id: "loanTemplateTitle", label: "طرح تسهیلات" },
  { id: "organizationName", label: "سازمان" },
  { id: "financialSupplierName", label: "تامین کننده مالی" },
  { id: "bankReferenceCode", label: "شناسه تسهیلات" },
  { id: "installmentCount", label: "تعداد اقساط معوق" },
  {
    id: "deferredInstallmentsAmount",
    label: "مجموع اقساط معوق (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "instalmentPenaltyAmount",
    label: "مجموع جریمه دیرکرد (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "totalDebt",
    label: "مجموع بدهی (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
];
let muiSelected: any;

export default function DeferredOnlineInstallments() {
  const jsonFile = useSelector((state: any) => state.style);
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<TableFilter>();

  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    id: number;
    pageNumber: number;
    clickOnBack: boolean;
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }>();
  const [data, setData] = useState<GetDeferredOnlineInstallmentsResponse[]>([]);
  const [referenceKey, setReferenceKey] = React.useState<string>();
  const [valueCustomerFullName, setValueCustomerFullName] = useState<string>();
  const [valueReferenceKey, setValueReferenceKey] = React.useState<string>();
  const [valueCustomerNationalCode, setValueCustomerNationalCode] = useState<
    string
  >();
  const [valueLoanTemplateOptions, setValueLoanTemplateOptions] = useState<
    number[]
  >([]);
  const [valueLoanTemplate, setValueLoanTemplate] = useState<any[]>([]);
  const [valueFinancialSupplier, setValueFinancialSupplier] = useState<
    number[]
  >([]);
  const [financialSupplierResponse, setFinancialSupplierResponse] = useState<
    any[]
  >([]);
  const [valueOrganizationOptions, setValueOrganizationOptions] = useState<
    number[]
  >([]);
  const [valueOrganization, setValueOrganization] = useState<any[]>([]);
  const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [financilaSuppliers, setFinancialSuppliers] = useState<
    IDropdownResponse[]
  >([]);
  const [organizationOptions, setOrganizationOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );
  function changeValueLoanTemplateOptions(e: any, value: any) {
    setValueLoanTemplateOptions(e);
    setValueLoanTemplate(value);
  }
  function changeFinancilaSuppliers(e: any, value: any) {
    setValueFinancialSupplier(e);
    setFinancialSupplierResponse(value);
  }
  function changeValueOrganizationOptions(e: any, value: any) {
    setValueOrganizationOptions(e);
    setValueOrganization(value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget?.value);
  }
  function changeValueCustomerName(e: any) {
    setValueCustomerFullName(e.currentTarget?.value);
  }
  React.useEffect(() => {
    GetLoanTemplatesMutate();
    GetFinancialSuppliersMutate({});
    GetOrganizationsMutate();
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<TableFilter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        setValueCustomerFullName(filterData!.customerFullName);
        setValueCustomerNationalCode(filterData!.customerNationalCode!);
        setValueLoanTemplate(filterData!.valueLoanTemplate!);
        setValueLoanTemplateOptions(filterData?.loanTemplateIds!);
        setValueOrganizationOptions(filterData!.organizationIds!);
        setValueFinancialSupplier(filterData!.financialSupplierIds!);
        setValueFilterData(filterData);
      }
    } else {
      filterData = null;
      queryClient.setQueryData(TABLE_FILTER, null);
      let filter = {} as TableFilter;
      queryClient.setQueryData(TABLE_FILTER, filter);
      filter.financialSupplierIds = [];
      filter.organizationIds = [];
      filter.loanTemplateIds = [];
      filter.customerNationalCode = "";
      filter.customerFullName = "";
      setValueFilterData(filter);
    }
    fillData(filterData!);
  }, []);

  const { mutate: GetLoanTemplatesMutate } = useMutation(GetLoanTemplates, {
    onSuccess: (data: GetStatusResponse[]) => {
      if (data) {
        setLoanTemplateOptions(data);
      }
    },
    onError: () => {},
  });
  const { mutate: GetFinancialSuppliersMutate } = useMutation(
    GetFinancialSuppliers,
    {
      onSuccess: (data: IDropdownResponse[]) => {
        if (data) {
          setFinancialSuppliers(data);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetOrganizationsMutate } = useMutation(GetOrganizations, {
    onSuccess: (data: GetStatusResponse[]) => {
      if (data) {
        setOrganizationOptions(data);
      }
    },
    onError: () => {},
  });
  const { mutateAsync: GetDeferredOnlineInstallmentsMutate } = useMutation(
    GetDeferredOnlineInstallments,
    {
      onSuccess: (
        data: ApiResultModel<GetDeferredOnlineInstallmentsResponse[]>
      ) => {
        setData(data.data!);
        setPageInfo(data.pageInfo);
      },
    }
  );

  const GetDeferredOnlineInstallmentsReportExcelMutate = useMutation(
    GetDeferredOnlineInstallmentsReportExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );
  const setChildValueReferenceKey = (childValues: any) => {
    setValueReferenceKey(undefined);
    const tabelFilter = queryClient.getQueryData<TableFilter>(TABLE_FILTER);
    // if (tabelFilter !== undefined) tabelFilter!.referenceKey = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueFinancial = (childValues: TableFilter) => {
    const selectedItem = valueFinancialSupplier.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = financialSupplierResponse.filter(
      (item: any) => item.id != childValues
    );
    setValueFinancialSupplier(selectedItem);
    setFinancialSupplierResponse(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<TableFilter>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter!.financialSupplierIds = tabelFilter!.financialSupplierIds
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueOrganization = (childValues: TableFilter) => {
    const selectedItem = valueOrganizationOptions.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueOrganization.filter(
      (item: any) => item.id != childValues
    );
    setValueOrganizationOptions(selectedItem);
    setValueOrganization(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<TableFilter>(TABLE_FILTER);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.organizationIds = tabelFilter!.organizationIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<TableFilter>(TABLE_FILTER);
    if (tabelFilter != undefined) tabelFilter!.customerNationalCode = "";
    fillData(tabelFilter!);
  };
  const setChildValueCustomerName = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerFullName(selectedItem);
    const tabelFilter = queryClient.getQueryData<TableFilter>(TABLE_FILTER);
    if (tabelFilter != undefined) tabelFilter!.customerFullName = "";
    fillData(tabelFilter!);
  };

  const setChildValueLoanTemplate = (childValues: TableFilter) => {
    const selectedItem = valueLoanTemplate.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueLoanTemplate.filter(
      (item: any) => item.id != childValues
    );
    setValueLoanTemplateOptions(selectedItem);
    setValueLoanTemplate(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<any>(TABLE_FILTER);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.loanTemplateIds = tabelFilter!.loanTemplateIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
      tabelFilter!.valueLoanTemplate = tabelFilter!.valueLoanTemplate
        ?.filter((item: any) => item.id != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const generateFilter = (filterData: TableFilter): TableReportRequest => {
    let request = new TableReportRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: TableFilter) => {
    let filter = generateFilter(filterData);
    GetDeferredOnlineInstallmentsMutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<TableFilter>(TABLE_FILTER);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };

  function deleteChip() {
    setValueLoanTemplateOptions([]);
    setValueLoanTemplate([]);
    setValueFinancialSupplier([]);
    setFinancialSupplierResponse([]);
    setValueOrganizationOptions([]);
    setValueCustomerNationalCode(undefined);
    setValueCustomerFullName(undefined);
    setValueReferenceKey(undefined);
    setReferenceKey("");
    setValueCustomerNationalCode("");
    queryClient.setQueryData(TABLE_FILTER, null);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = {} as TableFilter;
  const handleDetail = (referenceKey: string) => {
    window.sessionStorage.setItem("idFind", referenceKey);
    window.sessionStorage.setItem("loanRequestId", "");
    window.sessionStorage.setItem("natinalCode", "");
    localStorage.setItem(
      "SUPPLIER_REQUEST_DATA",
      JSON.stringify({ referenceKey: referenceKey })
    );
    const newWindow = window.open(
      "/#/Search/SupplierSearch1/request-find-detail",
      "_blank"
    );
    newWindow?.history.pushState(
      {
        settlementData: { referenceKey: referenceKey },
      },
      "",
      "/Search/SupplierSearch1/request-find-detail"
    );
  };

  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    GetDeferredOnlineInstallmentsReportExcelMutate.mutate(
      valueFilterData ? valueFilterData! : ({} as TableFilter)
    );
  };

  return (
    <div>
      <Tooltip title="فیلتر" arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values: any) => {
              values.loanTemplateIds = valueLoanTemplateOptions;
              values.financialSupplierIds = valueFinancialSupplier;
              values.organizationIds = valueOrganizationOptions;
              values.customerNationalCode = valueCustomerNationalCode;
              values.customerFullName = valueCustomerFullName;
              values.referenceKey = valueReferenceKey;
              queryClient.setQueryData(TABLE_FILTER, values);
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"متقاضی"}
                      label={"متقاضی"}
                      required={false}
                      value={valueCustomerFullName}
                      onChange={changeValueCustomerName}
                      name="customerName"
                      id="customerName"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      helperText={""}
                      placeHolder={"کدملی"}
                      label={"کدملی"}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name="customerNationalCode"
                      id="customerNationalCode"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <AutocomplateCheckbox
                            id="loanTemplateIds"
                            name="loanTemplateIds"
                            value={valueLoanTemplateOptions}
                            label="طرح تسهیلات"
                            options={loanTemplateOptions}
                            onChange={changeValueLoanTemplateOptions}
                            changeMultiSelect={changeValueLoanTemplateOptions}
                            responseValue={valueLoanTemplate}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <AutocomplateCheckbox
                            id="financialSupplierIds"
                            name="financialSupplierIds"
                            value={valueFinancialSupplier}
                            label="تامین کننده مالی"
                            options={financilaSuppliers}
                            onChange={changeFinancilaSuppliers}
                            changeMultiSelect={changeFinancilaSuppliers}
                            responseValue={financialSupplierResponse}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <AutocomplateCheckbox
                            id="organizationIds"
                            name="organizationIds"
                            value={valueOrganizationOptions}
                            label="سازمان"
                            options={organizationOptions}
                            onChange={changeValueOrganizationOptions}
                            changeMultiSelect={changeValueOrganizationOptions}
                            responseValue={valueOrganization}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ paddingTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {valueFinancialSupplier?.length ||
                valueLoanTemplateOptions?.length ||
                valueOrganizationOptions?.length ||
                valueCustomerNationalCode ||
                valueCustomerFullName ||
                valueReferenceKey ? (
                  <div className="row tableCMP">
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5} style={{ marginTop: "20px" }}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src="images/RemoveAllFilters.svg"
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "10px" }}
                      >
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                        <ChipCmp
                          item={valueCustomerFullName}
                          enamValue={valueCustomerFullName}
                          index={valueCustomerFullName?.length}
                          setChildValue={setChildValueCustomerName}
                        />
                        <ChipCmp
                          item={valueLoanTemplateOptions}
                          enamValue={loanTemplateOptions}
                          index={valueLoanTemplateOptions?.length}
                          setChildValue={setChildValueLoanTemplate}
                        />
                        <ChipCmp
                          item={valueFinancialSupplier}
                          enamValue={financilaSuppliers}
                          index={valueFinancialSupplier?.length}
                          setChildValue={setChildValueFinancial}
                        />
                        <ChipCmp
                          item={valueOrganizationOptions}
                          enamValue={organizationOptions}
                          index={valueOrganizationOptions?.length}
                          setChildValue={setChildValueOrganization}
                        />
                        <ChipCmp
                          item={valueReferenceKey}
                          enamValue={valueReferenceKey}
                          index={valueReferenceKey?.length}
                          setChildValue={setChildValueReferenceKey}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className={`${data?.length > 0 ? "boxScrollSubmit" : ""}`}
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>

            <TableBody
              style={{
                height: "30px",
                minHeight: "30px",
              }}
            >
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    onClick={() => handleDetail(row.referenceKey)}
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                        (currentPaginationInfo.pageSize! ?? 0) +
                        rowIndex +
                        1}
                    </TableCell>
                    {columns?.map((column) => {
                      const value =
                        row[
                          column.id as keyof GetDeferredOnlineInstallmentsResponse
                        ];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat ? (
                            column.format(value)
                          ) : column.id === "saleStatusTitle" ? (
                            <b style={{ color: "#FB8C00" }}> {value}</b>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={Math.ceil(pageInfo.total / pageInfo.pageSize)}
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
}
